import * as React from "react";
import {cx} from "emotion";

import "./user-create-tabs.scss";

import {cst, cstAssign}          from "@Common/react/chain-services";
import {Types}                   from "@Common/types";
import {addURLParameterToWindow} from "@Common/utils/add-url-parameter";

interface VarStack {
    tabs: Array<{
        tab: string;
        label: string;
    }>,
}

export const UserCreateTabs = ({step}) : ({step: Types.Common.React.UseState.UseStateNext<number>}) => cst<VarStack>(
    cstAssign("tabs",({}, next) => next(getTabs())),
    ({tabs}) => (
        <div className="user-create-tabs-f7u">
            {tabs.map((menuItem, i) => (
                <div {...{
                    className: cx("tab", {active: step.value === i, disabled: i > step.value}),
                    key: menuItem.label,
                    "aria-label": menuItem.label,
                    "xd-qa-type": "tab",
                    "xd-qa-name": menuItem.label,
                    onClick: () => {
                        if(i < step.value) {
                            addURLParameterToWindow({parameter: "step", value: menuItem.tab});
                            step.onChange(i);
                        }
                    },
                }}>
                    {menuItem.label}
                </div>
            ))}
    </div>
    )
);

const getTabs = () => ([
    {
        tab: "general",
        label: "General Info"
    },
    {
        tab: "login",
        label: "Login Info"
    },
    {
        tab: "customization",
        label: "Customization"
    },
    {
        tab: "confirm",
        label: "Confirm"
    },
]);

export const USER_TAB = {
    GENERAL: 0,
    LOGIN: 1,
    CUSTOMIZATION: 2,
    CONFIRM: 3
}

export const controlInput = ''

export const goToNextTab = (step) => {
    const tabs = getTabs()
    addURLParameterToWindow({parameter: "step", value: tabs[step.value + 1].tab});
    step.onChange(step.value + 1);
}

export const goToPreviousTab = (step) => {
    const tabs = getTabs()
    addURLParameterToWindow({parameter: "step", value: tabs[step.value - 1].tab});
    step.onChange(step.value - 1);
}
